import { getTeamsById } from "core-integration/src/store/teams/reducers";
import AddElement from "plos/src/components/AddElement";
import { Button } from "plos/src/components/buttons/Button";
import ElementDialogButton from "plos/src/components/ElementDialogButton";
import ElementInTable from "plos/src/components/ElementInTable";
import {
  listTableCell,
  listTableElement,
  listTableElementWrap,
  listTablePlaceholderButtonWrap,
  listTablePositionCell,
  listTableRowStyles,
} from "plos/src/styles/listTables.css";
import { visuallyHidden } from "plos/src/styles/utils.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import OverlayCells from "../../../ListViewTable/OverlayCells";
import { SquadListTableRowProps } from "./types";

const SquadListTableRow = ({
  currencyDivisor,
  elementTypesByPosition,
  showElementType,
  pos,
  proposedElements,
  handleOpenElemListSheet,
  handleElementClick,
  overlay,
  stats,
  columnCount,
}: SquadListTableRowProps) => {
  const { t } = useTranslation("pickTeam");

  const teamsById = useSelector(getTeamsById);
  const element = proposedElements[pos];

  if (!elementTypesByPosition) {
    return null;
  }

  return (
    <tr className={listTableRowStyles}>
      {element ? (
        <>
          <th scope="row" className={listTableElement}>
            <span className={visuallyHidden}>
              {element.web_name}, {teamsById[element.team].name}
            </span>
            <div className={listTableElementWrap} aria-hidden="true">
              <ElementDialogButton elementId={element.id} variant="list" />
              <ElementInTable
                element={element}
                team={teamsById[element.team]}
                actionMe={() => handleElementClick(pos)}
              />
            </div>
          </th>
          <OverlayCells
            overlay={overlay}
            element={element}
            stats={stats}
            currencyDivisor={currencyDivisor}
          />
          <td className={listTableCell}>
            <AddElement element={element} filterByElementTypeOnRemove />
          </td>
        </>
      ) : (
        <th
          scope="row"
          className={listTablePositionCell}
          colSpan={columnCount + 2}
        >
          <div className={listTablePlaceholderButtonWrap}>
            <Button
              appearance="tonal"
              size="small"
              onPress={() => {
                showElementType(elementTypesByPosition[pos].thisType.id);
                handleOpenElemListSheet();
              }}
            >
              {t("select", "Select")}{" "}
              {elementTypesByPosition[pos].thisType.singular_name}
            </Button>
          </div>
        </th>
      )}
    </tr>
  );
};

export default SquadListTableRow;
